export default __webpack_public_path__ + "static/media/40.8fda8165.png";